import React, { Component } from 'react'
import { Button, Text } from 'components/base'

class EmailPassword extends Component {
  renderSwitch() {
    const { onEnable } = this.props
    return (
      <div className="padding-top-large">
        <Text.Subtitle className="margin-bottom-small padding-top-huge border-top-small border-shade-40">
          Cancel SSO
        </Text.Subtitle>

        <div>
          <div className="shade-10 line-height-larger margin-bottom-large">
            Your team will revert to logging in with email and password.
            <br />
            An email will be sent to all members in your team to notify them of
            this change.
          </div>
          <div className="margin-top-small">
            <Button.Danger onClick={onEnable}>Remove SSO</Button.Danger>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { organization } = this.props
    return (
      <div className="margin-bottom-larger">
        {organization.get('authMethod') === 'emailPassword'
          ? false
          : this.renderSwitch()}
      </div>
    )
  }
}

export default EmailPassword
